<template>
  <div class="modalFooter">
    <b-modal
      id="wrapper__notification_setting"
      ref="my-modal"
      v-model="showmodal"
      crm_at="modal_notification"
      hide-header
      hide-footer
      hide-header-close
      no-close-on-backdrop
    >
      <div :class="currentLocale">
        <!-- Header -->
        <div class="content-body">
          <div class="header-container">
            <b-button
              id="back-button"
              class="back-button"
              crm_at="btn_back_editprofile"
              @click="goback()"
            >
              <img src="@/assets/images/Btn_Back.svg" alt="" />
            </b-button>
            <p class="header-title" crm_at="text-title-setting-marketing">
              {{ titleMarketing }}
            </p>
          </div>
          <!-- Marketing -->
          <div class="topic">
            <p class="topic-message">
              {{ titleMessage }}
            </p>
          </div>
          <div class="switch-container col-12">
            <div class="row content-switch">
              <div class="col-6 switch-name">{{ lbl.consent.noti.email }}</div>
              <div class="col-6 action-switch">
                <a-switch v-model="notification.email" />
              </div>
            </div>
            <div class="row content-switch">
              <div class="col-6 switch-name">{{ lbl.consent.noti.sms }}</div>
              <div class="col-6 action-switch">
                <a-switch v-model="notification.sms" />
              </div>
            </div>
            <div
              v-if="loginTypeList.includes('Line')"
              class="row content-switch"
            >
              <div class="col-6 switch-name">{{ lbl.consent.noti.line }}</div>
              <div class="col-6 action-switch">
                <a-switch v-model="notification.line" />
              </div>
            </div>
          </div>
        </div>

        <!-- Support PC Tablet -->
        <div v-if="windowWidth >= 600 && windowHeight >= 600">
          <div v-if="modalcondition.isshowbtn" class="wrapper-agree">
            <div
              id="submitbtn_setting_marketing"
              class="btn-setting-marketing"
              :style="{
                backgroundColor: modalcondition.storeinfo.buttoncolor,
                border: modalcondition.storeinfo.buttoncolor,
                color: modalcondition.storeinfo.buttontextcolor,
              }"
              crm_at="submitbtn_setting_marketing"
              @click="submitbtn"
            >
              {{ lbl.default.confirm }}
            </div>
          </div>
        </div>

        <div v-else>
          <div v-if="modalcondition.isshowbtn" class="wrapper-agree">
            <div class="col">
              <div
                id="submitbtn_setting_marketing"
                class="btn-setting-marketing"
                :style="{
                  backgroundColor: modalcondition.storeinfo.buttoncolor,
                  border: modalcondition.storeinfo.buttoncolor,
                  color: modalcondition.storeinfo.buttontextcolor,
                }"
                crm_at="submitbtn_setting_marketing"
                @click="submitbtn"
              >
                {{ lbl.default.confirm }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
import Locale from '@/helper/Locale.js'
export default {
  mixins: [CommonMixin, ResponsiveMixin],
  props: {
    title: String,
    busModal: Object,
    modalcondition: Object,
    loginType: String,
    callback: {
      type: Function,
    },
  },
  data() {
    return {
      showmodal: this.modalcondition.ismodalShow,
      currentLocale: Locale.getLocale(),
      modalShow: true,
      IsPDPA: false,
      isagree: false,
      titleMarketing: '',
      titleMessage: '',
      notification: {
        email: this.modalcondition.notification.email
          ? this.modalcondition.notification.email
          : false,
        sms: this.modalcondition.notification.sms
          ? this.modalcondition.notification.sms
          : false,
        line: this.modalcondition.notification.line
          ? this.modalcondition.notification.line
          : false,
      },
      loginTypeList: [],
    }
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      if (modalId == 'wrapper__notification_setting') {
        this.$refs['my-modal'].hide()

        this.$emit('ChangeErrorSettingMarketing', false)
      }
    })
    this.arrList(this.loginType)
    this.titleMarketing = this.lbl.consent.notification_setting
    this.titleMessage = this.lbl.consent.notification_setting_title
  },
  methods: {
    arrList(string) {
      var list = string.split(',')
      this.loginTypeList = list
      return list
    },
    callbackEndread() {
      this.isagree = true
    },
    showModal() {
      this.$refs['my-modal'].show()
    },
    submitbtn() {
      this.modalcondition.ismodalShow = true
      this.$refs['my-modal'].hide()
      let data = {
        confirm: 'agree',
        notification: this.notification,
      }
      this.callback(data)
    },
    toggleModal() {
      this.$refs['my-modal'].toggle('#toggle-btn')
    },
    goback() {
      this.$bvModal.hide('wrapper__notification_setting')
    },
  },
}
</script>
<style lang="scss">
@import '@/style/_mixin.scss';
#wrapper__notification_setting___BV_modal_outer_ {
  .ant-switch {
    height: 16px;
    &:after {
      width: 24px;
      height: 24px;
      background-color: #033a70;
      top: -5px;
    }
  }
  .ant-switch-checked {
    background-color: #82b1ff;
    &:after {
      margin-left: 0px;
    }
  }
  .header-container {
    display: flex;
    align-items: center;
    font-size: 21px;
    padding: 8px 0;

    .back-button {
      background: transparent;
      border: none;
      padding: 0;
    }

    .header-title {
      text-align: left;
      margin: 0px 15px;
      font-weight: 500;
      word-break: break-word;
    }
  }

  .modal-body {
    padding: 0;
  }

  .switch-container {
    padding: 0 20px;
  }
  .content-switch {
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #f5f5f5;
    .action-switch {
      text-align: end;
    }
    .switch-name {
      font-size: 20px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: 0.5px;
      text-align: left;
      color: $color-body;
    }
  }
  .topic {
    background-color: #fafafa;
    padding: 0 20px;

    .topic-message {
      font-size: 14px;
      letter-spacing: 0.15px;
      color: #616161;
      padding: 8px 0;
    }
  }
  .icheck-primary {
    display: flex;
    gap: 8px;
    align-items: center;
  }
  .icheck-primary > input:first-child:checked + label::before {
    background-color: #666666 !important;
    border-color: #666666 !important;
  }
  .modal-content {
    border-radius: 0;
  }
  .modal-title {
    text-align: left;
    padding: 10px;
    margin: 0px 15px;
    .text-title-policy {
      text-indent: 0px;
      padding: 4px 4px;
      position: relative;
      left: -35px;
      font-size: 21px;
      @include breakpoint-max(320) {
        font-size: 14px;
      }
      font-weight: 500;
      word-break: break-word;
      white-space: pre-line;
    }
  }
  #wrapper-marketing {
    overflow-y: scroll;
    overflow-x: hidden;
    height: 62vh;
    @include breakpoint-max(375) {
      height: 54.5vh;
    }
    .content {
      word-break: break-word;
      white-space: pre-line;
    }
  }
  #output {
    padding: 1rem 0;
  }
  .modal-dialog {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    padding: 0;
    margin: 0;
    max-width: unset !important;
    .modal-content {
      position: fixed;
      top: 0;
      bottom: 0;
    }
    .modal-title {
      font-size: 15px;
    }
  }
  .logo {
    width: 56px;
    height: 56px;
    margin: -10px -55px 0px;
    border-radius: 1000px;
  }

  .serv ul {
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
  }

  .serv ul li {
    list-style: none;
    flex: 0 0 33.333333%;
  }
}

#wrapper__notification_setting___BV_modal_outer_ {
  .modal-dialog {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    padding: 0;
    margin: 0;
  }

  @mixin btn() {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    border-radius: 100px;
    box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.35);
    background-color: #033a70;
    color: white;
    font-size: 18px;
    height: 50px;
  }
  .btn__Register {
    @include btn();
    width: 335px;
    position: relative;
    top: 10px;
    @include breakpoint-max(320) {
      width: 270px !important;
    }
  }
  .btn-terms {
    opacity: 0.3;
    pointer-events: none;
    @include btn();
    width: 335px;
    position: relative;
    top: 10px;
    @include breakpoint-max(320) {
      width: 270px !important;
    }
  }

  .btn-setting-marketing {
    @include btn();
    @include breakpoint-max(320) {
      width: 100px !important;
    }
  }
  .disagree {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #666;
    font-weight: 500;
  }
  .wrapper-agree {
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 20px;
    z-index: 1;
    width: 100%;
  }
}

@media only screen and (min-device-width: 600px) and (min-device-height: 600px) {
  #wrapper__notification_setting___BV_modal_outer_ {
    .modal-dialog {
      top: 50%;
      left: 50%;
      bottom: unset;
      transform: translate(-50%, -50%);
      width: 90%;
      max-width: unset !important;
      .modal-content {
        height: 90vh;
      }
    }
    .modal-content {
      border-radius: 8px;
    }
    .modal-header {
      width: 100%;
      margin-left: unset;
      height: auto;
    }
    .modal-title {
      margin: unset;
      padding: unset;
      .text-title-policy {
        left: 0;
        font-size: 24px;
        padding: 5px 15px;
      }
    }
    #wrapper-privacy {
      height: calc(90vh - 220px);
      padding: 0 40px;
    }
    #wrapper-terms {
      height: calc(90vh - 220px);
      padding: 0 40px;
    }
    .wrapper-agree {
      padding: 0 28px;
    }
    .btn-disagree {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      color: #666;
      font-weight: 600;
    }
    .btn-setting-marketing {
      height: 52px;
      margin: 0 12px;
      cursor: pointer;
      box-shadow: unset;
    }
    .btn-terms {
      height: 52px;
      width: 80%;
      top: 0;
      cursor: pointer;
    }
  }
}
</style>
